<template>
  <div>
    <h2 v-if="!isPusat && !isEdit" class="black--text">Daftar Data Kepala Sekolah</h2>
    <base-table-header
      :options="{
        header: 'pa-0',
        filterOutline: true,
        reloadOutline: true,
        searchOutline: true,
        downloadOutline: true,
      }"
      btn-filter
      btn-download
      @search="onSearch"
      @filter="onFilter"
      @reload="onReload"
      @download="onDownload"
    >
      <template v-slot:subtitle>
        <div class="my-auto body-2">
          <span class="blue--text">{{ total }}</span> Data Kepala Sekolah pada {{ $getMasterText(mJenjang, kJenjang) }}
        </div>
      </template>
      <template v-slot:toolbarAfter>
        <div class="ml-2">
          <v-select
            v-model="kJenjang"
            :items="mJenjang"
            placeholder="Semua Jenjang"
            dense
            outlined
            hide-details
            style="max-width: 180px"
            @input="onFilterJenjang"
          ></v-select>
        </div>
      </template>
    </base-table-header>
    <base-list-filter
      ref="filter"
      title="Pilih Filter Status"
      :filtered="filtered"
      :filters="formFilter"
      :paramsFilter="filters"
      @save="filterSave"
    />
    <base-list-table
      class="mt-5"
      :hideHeader="true"
      :loading="loading"
      :item="data"
      :total="total"
      :usePaging="false"
      @fetch="fetchData"
    >
      <template slot-scope="{ item }">
        <td>
          <v-list three-line class="my-1">
            <v-list-item dense class="px-0" style="align-items: unset">
              <v-list-item-avatar color="secondary">
                <v-icon dark>mdi-account</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" md="4">
                    <span class="info--text mb-0" style="font-size: 17px">
                      {{ $getDeepObj(item, 'ptk_kasek.nama') || '-' }}
                    </span>
                    <div class="mt-1 mb-0">
                      <strong>No UKG:</strong> {{ $getDeepObj(item, 'ptk_kasek.no_ukg') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Jenis PTK:</strong> {{ getInfoPtk(item, 'm_jenis_ptk.jenis_ptk') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Tugas Tambahan:</strong> {{ getInfoTugas(item, 'm_tugas.keterangan') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Status Keaktifan:</strong>
                      {{ getInfoPtk(item, 'm_keluar.keterangan', 'ptk_sekolah.m_keluar.keterangan') || 'Aktif' }}
                    </div>
                    <div class="mt-1">
                      <strong>Status Kepegawaian:</strong>
                      {{ getInfoPtk(item, 'm_pegawai.keterangan') || '-' }}
                    </div>
                    <div class="mt-1">
                      <strong>Status Lulus PPPK 2021:</strong>
                      {{ +item.is_lulus_p3k_2021 ? 'Lulus' : '-' }}
                    </div>
                    <div class="mt-1">
                      <v-icon color="success" small dark> mdi-whatsapp </v-icon>
                      {{ $getDeepObj(item, 'ptk_kasek.no_hp') || '-' }}
                    </div>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-row>
                      <v-col cols="12" md="5">
                        <span class="body-2 grey--text text--darken-1">Informasi Sekolah</span>
                        <div>
                          <span class="mb-0" style="font-size: 17px">
                            {{ getInfoSekolah(item, 'nama') }}
                          </span>
                        </div>
                        <div class="mt-1 mb-0"> <strong>NPSN:</strong> {{ getInfoSekolah(item, 'npsn') }} </div>
                        <div class="mt-1 mb-0">
                          <strong>Status:</strong>
                          {{ Number(getInfoSekolah(item, 'is_negeri')) === 1 ? 'Negeri' : 'Swasta' }}
                        </div>
                        <div class="mt-1 mb-0"> <strong>Alamat:</strong> {{ getInfoSekolah(item, 'alamat') }} </div>
                        <div class="mt-1 mb-0">
                          <strong>Kab / Kota:</strong> {{ getInfoSekolah(item, 'm_kota.keterangan') }}
                        </div>
                        <div class="mt-1">
                          <strong>Provinsi:</strong> {{ getInfoSekolah(item, 'm_propinsi.keterangan') }}
                        </div>
                      </v-col>
                      <v-col v-if="!isEdit" cols="12" sm="12" md="4">
                        <div class="mb-4">
                          <span class="body-2 grey--text text--darken-1">Status Kandidat</span>
                          <div>
                            <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-account </v-icon>
                            <span class="body-2 font-weight-medium black--text">
                              {{
                                Number($getDeepObj(item, 'psp_profil.is_cadangan') || 0) > 0
                                  ? `Akselerasi ${$getDeepObj(item, 'psp_profil.is_cadangan')}`
                                  : 'Reguler'
                              }}
                            </span>
                          </div>
                          <div v-if="+item.is_prioritas === 1" class="orange--text text--darken-3">
                            <v-icon color="info" small dark style="margin-bottom: 3px"> mdi-crown </v-icon> Prioritas
                            diterima
                          </div>
                        </div>
                        <div>
                          <span class="body-2 grey--text text--darken-1">Hasil Verval</span>
                          <div>
                            <v-chip
                              :color="
                                item.k_verval_peringkat_psp === 4
                                  ? 'orange'
                                  : item.k_verval_peringkat_psp === 3
                                  ? 'red'
                                  : item.k_verval_peringkat_psp === 2
                                  ? 'green'
                                  : 'grey'
                              "
                              class="white--text"
                            >
                              {{ $getDeepObj(item, 'm_verval_peringkat_psp.keterangan') }}
                            </v-chip>
                          </div>
                          <div v-if="[3, 4].includes(item.k_verval_peringkat_psp)" class="mt-1 body-2">
                            <v-icon color="black" small dark> mdi-account-cancel </v-icon>
                            {{ item.catatan_verval }}
                          </div>
                          <div v-if="item.k_verval_peringkat_psp === 3" class="mt-1 body-2">
                            <v-icon color="info" small dark class="mr-1"> mdi-file-document </v-icon>
                            <a :href="item.url_verval" target="_blank" class="text-decoration-underline">
                              Lihat dokumen pendukung
                            </a>
                          </div>
                        </div>
                      </v-col>
                      <v-col v-if="!isEdit" cols="12" sm="12" md="3">
                        <div v-if="$allow('psp-peringkat-kandidat.verval')">
                          <span class="body-2 grey--text text--darken-1">Aksi</span>
                          <div>
                            <v-btn :outlined="item.k_verval_peringkat_psp > 1" color="primary" @click="onVerval(item)">
                              <v-icon left>mdi-pencil</v-icon>Verval
                            </v-btn>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-list-item-content>
              <v-list-item-action-text class="mt-7">
                <base-list-action
                  v-if="isPusat || isBatalVerval(item)"
                  :data="item"
                  :actions="actions"
                  :allow="allow"
                  @action="onAction"
                />
                <div v-else><v-btn icon></v-btn></div>
              </v-list-item-action-text>
            </v-list-item>
          </v-list>
        </td>
      </template>
    </base-list-table>
    <v-card-actions>
      <base-table-footer :pageTotal="pageTotal" @changePage="onChangePage"></base-table-footer>
    </v-card-actions>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import actions from './actions';
export default {
  name: 'verval-list',
  mixins: [list],
  props: {
    isPusat: {
      type: Boolean,
      default: false,
    },
    mJenjangPusat: {
      type: Array,
      default: () => [],
    },
    detailId: {
      type: Number,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      actions: actions,
      kJenjang: '',
      ori: [],
      kandidats: [],
    };
  },

  computed: {
    ...mapState('peringkat', {
      mJenjangs: (state) => state.m_jenjangs || [],
      pspPeringkat: (state) => state.psp_peringkat || {},
    }),

    mJenjang() {
      return [
        ...[{ text: 'Semua Jenjang', value: '' }],
        ...(this.isPusat ? this.mJenjangPusat : this.mJenjangs)
          .filter((jenjang) => jenjang.k_jenjang <= 6)
          .map((jenjang) => {
            return {
              text: jenjang.singkat,
              value: jenjang.k_jenjang,
            };
          }),
      ];
    },

    formFilter() {
      return [
        {
          label: 'Status Verval Data',
          model: 'k_verval_peringkat_psp',
          type: 'select',
          props: ['attach'],
          master: [
            { text: 'Belum Diverval', value: '1' },
            { text: 'Data Sesuai', value: '2' },
            { text: 'Diskualifikasi', value: '3' },
            { text: 'Proses Perbaikan', value: '4' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Status Sekolah',
          model: 'is_negeri',
          type: 'select',
          props: ['attach'],
          master: [
            { text: 'Negeri', value: '1' },
            { text: 'Swasta', value: '0' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Status Kandidat ',
          model: 'is_cadangan',
          type: 'select',
          props: ['attach'],
          master: [
            { text: 'Semua Kandidat', value: '' },
            { text: 'Reguler', value: '0' },
            { text: 'Akselerasi 1', value: '1' },
            { text: 'Akselerasi 2', value: '2' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
        {
          label: 'Jabatan',
          model: 'is_definitif',
          type: 'select',
          props: ['attach'],
          master: [
            { text: 'Semua Jabatan', value: '' },
            { text: 'Kepala Sekolah ', value: '1' },
            { text: 'PLT Kepala Sekolah', value: '0' },
          ],
          labelColor: 'secondary',
          grid: { cols: 12, md: 6 },
        },
      ];
    },

    filtersMaster() {
      return {
        is_negeri: { 1: 'Negeri', 0: 'Swasta' },
        k_verval_peringkat_psp: { 1: 'Belum Diverval', 2: 'Data Sesuai', 3: 'Diskualifikasi', 4: 'Status Perbaikan' },
        is_cadangan: { '': 'Semua Kandidat', '2': 'Akselerasi 2', '1': 'Akselerasi 1', '0': 'Kandidat Reguler' },
        is_definitif: { '': 'Semua Kandidat', '1': 'Kepala Sekolah', '0': 'PLT Kepala Sekolah' },
      };
    },
  },

  mounted() {
    this.attr = {
      action: 'kandidat',
    };
  },

  methods: {
    ...mapActions('peringkat', ['fetch', 'download']),

    ...mapActions('peringkatVerval', ['getKandidat', 'downloadList']),

    fetchData: function() {
      return new Promise((resolve) => {
        let params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
        const attr = Object.assign({}, this.attr);
        this[this.isPusat ? 'getKandidat' : 'fetch'](
          this.isPusat ? { params, attr, id: this.detailId } : { params, attr }
        ).then(({ data, meta, total, last_page }) => {
          this.data = data || [];
          this.total = meta?.total || total || 0;
          this.pageTotal = meta?.last_page || last_page || 1;
          this.params.limit = meta?.per_page || this.params.limit;
          this.statistik = meta?.statistik || {};
          this.config = meta?.config || {};
          resolve(true);
        });
      });
    },

    reset() {
      this.$set(this, 'ori', []);
      this.$set(this, 'kandidats', []);

      if (this.data && this.data.length) {
        this.data = [];
        this.onReload();
      }
    },

    isBatalVerval(item) {
      return item.k_verval_peringkat_psp > 1 && this.$allow('psp-peringkat-kandidat.batal-verval') && !this.isPusat;
    },

    getInfoPtk(data, key, keyAsal) {
      const isOri = Number(data.k_verval_peringkat_psp) !== 2;
      return this.$borangInfoPtk(data, isOri, key, keyAsal);
    },

    getInfoTugas(data, key) {
      const isOri = Number(data.k_verval_peringkat_psp) !== 2;
      return this.$borangInfoTugas(data, isOri, key);
    },

    getInfoSekolah(data, key) {
      const isOri = Number(data.k_verval_peringkat_psp) !== 2;
      return this.$borangInfoSekolah(data, isOri, key);
    },

    onFilterJenjang() {
      delete this.filters['k_jenjang'];

      if (this.kJenjang) {
        this.filters = Object.assign(this.filters, { k_jenjang: this.kJenjang });
      }
      Object.assign(this.params, { page: 1 });
      this.fetchData();
    },

    onDownload() {
      let params = Object.assign({}, this.params, this.$isObject(this.filters) ? this.filters : {});
      this[this.isPusat ? 'downloadList' : 'download'](
        this.isPusat
          ? { params, url: `${this.detailId}/kandidat-download` }
          : {
              action: 'kandidat',
              type: 'download',
              params: this.params,
            }
      ).then((url) => {
        window.open(url, '_blank');
      });
    },

    onVerval(data) {
      this.$emit('verval', data);
    },

    onBatalVerval(data) {
      this.$emit('batal', data);
    },

    onChangeData(data) {
      if (!this.isEdit) return;

      this.kandidats = [...[], ...this.kandidats];
      for (const dt of data) {
        if (Number(dt.is_sesuai) === 1) {
          if (!this.kandidats.includes(dt.psp_peringkat_kandidat_id)) {
            this.ori.push(dt.psp_peringkat_kandidat_id);
            this.kandidats.push(Number(dt.psp_peringkat_kandidat_id));
          }
        }
      }
    },

    onDeleteKandidat(data) {
      this.$emit('delete', data);
    },
  },

  watch: {
    data: 'onChangeData',
  },
};
</script>

<style scoped></style>
